<script setup>
import {useBaseStore} from "~/stores/base";
import Modal from "~/components/Modal.vue";
import Drawer from "~/components/Drawer.vue";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits(["confirm", "cancel"])

/** props **/
const props = defineProps({
  open: {
    default: false,
    required: true
  },
  premiumFee: {
    default: "",
    required: true
  }
})

/** data **/

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)

/** watch **/

/** methods **/

/** lifecycle **/

</script>

<template>
  <div class="modal-premium-confirm-mobile" v-if="isMobile">
    <Drawer
      :open="open"
      :btn-close-visible="true"
      @close="emits('cancel')"
      :position="'bottom'"
      :border-radius="'8px 8px 0 0'"
      :z-index="4"
      :global-header-visible="false"
    >
      <div class="content">
        <div class="title">Premium Pick!</div>
        <div class="text">This item comes with an extra ${{ premiumFee }} charge, added at checkout.</div>
        <div class="btn-primary" @click="emits('confirm')">
          <img class="icon" src="@/assets/img/icon-plus-black.svg" alt="icon">
          <span>add to my bnto</span>
        </div>
      </div>
    </Drawer>
  </div>
  <div class="modal-premium-confirm-desktop" v-else>
    <Modal
      :open="open"
      :title="'Premium Pick!'"
      :btn-close-visible="true"
      :btn-back-visible="false"
      @close="emits('cancel')"
      z-index="3"
    >
      <div class="content">
        <div class="text">This item comes with an extra ${{ premiumFee }} charge, added at checkout.</div>
        <div class="btn-primary" @click="emits('confirm')">
          <img class="icon" src="@/assets/img/icon-plus-black.svg" alt="icon">
          <span>add to my bnto</span>
        </div>
      </div>
    </Modal>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.modal-premium-confirm-mobile {
  .content {
    width: 100%;

    display: flex;
    flex-direction: column;

    padding: 0 20px 30px 20px;

    .title {
      width: 100%;
      text-align: center;
      padding: 27px 0;
      /* Eyebrow/medium */
      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 650;
      line-height: 18px; /* 128.571% */
      letter-spacing: -0.056px;
      text-transform: uppercase;
    }

    .text {
      padding: 24px 0;

      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 300;
      line-height: 20px; /* 142.857% */

      margin-bottom: 20px;
    }
  }
}

.modal-premium-confirm-desktop {
  .content {
    width: 374px;

    display: flex;
    flex-direction: column;
    gap: 20px;

    padding: 0 20px 30px 20px;

    .text {
      padding: 24px 0;

      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 300;
      line-height: 20px; /* 142.857% */
    }
  }
}
</style>
